import { render } from "./MundesiPunesimi.vue?vue&type=template&id=1dc4b943&scoped=true"
import script from "./MundesiPunesimi.vue?vue&type=script&lang=js"
export * from "./MundesiPunesimi.vue?vue&type=script&lang=js"

import "./MundesiPunesimi.vue?vue&type=style&index=0&id=1dc4b943&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc4b943"]])

export default __exports__